(ns quuppa.error-reporting
  "Report uncaught exceptions to the backend, rate limited with via a token bucket (allows to report small burts of errors, and limits error reporting rate).
  In order to use, add a HTTP POST route to the backend that accepts a JSON message at \"/api/js-error\" path"
  (:require [re-frame.core :as rf]
            [ajax.core :as ajax]
            [quuppa.token-bucket :as t])
  (:require-macros [quuppa.common.version :as version]))

(def default-burst
  "Burst of error reports allowed"
  10)

(def default-rate
  "Continuous rate of error reports allowed"
  1)

(rf/reg-event-fx
  :report/js-error
  (fn [_ [_ error]]
    {:fx [[:http-xhrio {:method          :post
                        :uri             "/api/js-error"
                        :params          error
                        :format          (ajax/json-request-format)
                        :response-format (ajax/json-response-format)
                        :on-success      [:report/js-error-success]
                        :on-failure      [:report/js-error-failure]}]]}))

(rf/reg-event-fx
  :report/js-error-success
  (fn []
    {}))

(rf/reg-event-fx
  :report/js-error-failure
  (fn []
    ;; Failed to report so just log
    (js/console.error "Failed to send error report")
    {}))

(defonce error-reporting-token-bucket-atom (atom nil))

(defn enable-error-reporting!
  ([]
   (enable-error-reporting! default-burst default-rate))
  ([burst rate]
   (when-not @error-reporting-token-bucket-atom
     (reset! error-reporting-token-bucket-atom (t/make-token-bucket burst rate))
     (.addEventListener js/window "error" (fn [^js e]
                                            (when (and (.-error e)
                                                       (not (.-reported (.-error e))))
                                              (when (t/consume error-reporting-token-bucket-atom)
                                                (rf/dispatch [:report/js-error {:error-info  {:message (.-message e)
                                                                                              :filename (.-filename e)
                                                                                              :lineno (.-lineno e)
                                                                                              :colno (.-colno e)
                                                                                              :error-name (-> e .-error .-name)
                                                                                              :stack (-> e .-error .-stack)}
                                                                                :user-agent (.-userAgent js/navigator)
                                                                                :version-info (version/get-version-info)}])
                                                ;; To prevent reporting twice, caused by React devtools probably
                                                (set! (.-reported (.-error e)) true))))))))

